import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { detectBrowserLanguage } from './libs/language';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            convertDetectedLanguage: detectBrowserLanguage,
        },
        // we init with resources
        resources: {
            en: {
                translations: {
                    'General': 'General',
                    'Dashboards,Widgets': 'Dashboards,Widgets',
                    'Dashboard': 'Dashboard',
                    'Default': 'Default',
                    'Ecommerce': 'Ecommerce',
                    'Widgets': 'Widgets',
                    'Chart': 'Chart',
                    'Applications': 'Applications',
                    'Ready to use Apps': 'Ready to use Apps'
                }
            },
            cn: {
                translations: {
                    'General': '一般',
                    'Dashboards': '仪表板',
                    'Widgets': '小部件',
                    'Dashboard': '仪表板',
                    'Default': '默认',
                    'Ecommerce': '电子商务',
                    'Chart': '图表',
                    'Applications': '应用领域',
                    'Ready to use Apps': '准备使用的应用程序'
                }
            },
            ae: {
                translations: {
                    'General': 'جنرال لواء',
                    'Dashboards': 'لوحات القيادة والحاجيات',
                    'Widgets': 'لوحات القيادة',
                    'Dashboard': 'لوحة القيادة',
                    'Default': 'إفتراضي',
                    'Ecommerce': 'التجارة الإلكترونية',
                    'Chart': 'مخطط',
                    'Applications': 'التطبيقات',
                    'Ready to use Apps': 'جاهز لاستخدام التطبيقات'
                }
            },
            du: {
                translations: {
                    'Home': 'Home',
                    'Yes': 'Ja',
                    'No': 'Nein',
                    'Tickets': 'Tickets',
                    'Concern': 'Meldung',
                    'Pages': 'Seiten',
                    'Hello': 'Hallo',
                    'Search': 'Suchen',
                    'Account': 'Konto',
                    'Username': 'Nutzername',
                    'Password': 'Passwort',
                    'Logout': 'Ausloggen',
                    'Settings': 'Einstellungen',
                    'how can I help you?' : 'wie kann ich dir helfen?',
                    'Welcome to Report Portal' : 'Hier können Sie Ereignisse melden oder Anträge einreichen.',
                    'Sign In': 'Anmelden',
                    'Enter your email & password to login': 'Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um sich anzumelden',
                    'Welcome to the Report Portal!': 'Willkommen im Meldungsportal!',
                    'Vacation': 'Urlaub',
                    'Support': 'Unterstützung',
                    'Financial': 'Finanziell',
                    'Please sign in': 'Bitte melden Sie Sich an',
                    'Form': 'Bilden',
                    'Tasks': 'Aufgaben',
                    'No Tasks': 'Keine Aufgaben',
                    'Comments': 'Kommentare',
                    'No Comments': 'Keine Kommentare',
                    'Type a message here...': 'Geben Sie hier eine Nachricht ein...',
                    'This field is required': 'Dieses Feld ist erforderlich',
                    'Submit': 'Einreichen',
                    'Submitting': 'Einreichen',
                    'Showing': 'Es werden',
                    'to': 'bis',
                    'of': 'von',
                    'entries': 'Einträgen angezeigt',
                    'Upload File(s)': 'Datei(en) hochladen',
                    'Click to upload file': 'Klicken Sie hier, um die Datei hochzuladen',
                    'Upload a file': 'Laden Sie eine Datei hoch',
                    'Take a picture': 'Machen Sie ein Foto',
                    'Select your country': 'Bitte wählen Sie das Land Ihrer Business Unit',
                }
            },
            es: {
                translations: {
                    'Home': 'Inicio',
                    'Yes': 'Sí',
                    'No': 'No',
                    'Tickets': 'Notificaciones',
                    'Concern': 'Solicitud',
                    'Pages': 'Páginas',
                    'Hello': 'Hola',
                    'Search': 'Buscar',
                    'Account': 'Cuenta',
                    'Username': 'Nombre de usuario',
                    'Password': 'Contraseña',
                    'Logout': 'Cerrar sesión',
                    'Settings': 'Ajustes',
                    'how can I help you?' : '¿En qué puedo ayudarle?',
                    'Welcome to Report Portal' : 'Aquí puede notificar incidencias o enviar solicitudes.',
                    'Sign In': 'Iniciar sesión',
                    'Enter your email & password to login': 'Ingrese su correo electrónico y contraseña para iniciar sesión',
                    'Welcome to the Report Portal!': '¡Bienvenido al Portal de Comunicaciones!',
                    'Vacation': 'Vacaciones',
                    'Support': 'Soporte',
                    'Financial': 'Financiero',
                    'Please sign in': 'Por favor inicia sesión',
                    'Form': 'Formulario',
                    'Tasks': 'Tareas',
                    'No Tasks': 'Sin tareas',
                    'Comments': 'Comentarios',
                    'No Comments': 'Sin comentarios',
                    'Type a message here...': 'Escriba un mensaje aquí...',
                    'This field is required': 'Este campo es obligatorio',
                    'Submit': 'Enviar',
                    'Submitting': 'Enviando',
                    'Showing': 'Mostrando',
                    'to': 'a',
                    'of': 'de',
                    'entries': 'entradas',
                    'Upload File(s)': 'Subir archivo(s)',
                    'Click to upload file': 'Haga clic para subir el archivo',
                    'Upload a file': 'Subir un archivo',
                    'Take a picture': 'Tomar una foto',
                    'Select your country': 'Seleccione el país de su unidad de negocio',
                }
            },
            fr: {
                translations: {
                    'General': 'Générale',
                    'Dashboards,Widgets': 'Tableaux de bord, widgets',
                    'Dashboard': 'Tableau de bord',
                    'Default': 'Défaut',
                    'Ecommerce': 'Commerce électronique',
                    'Widgets': 'Widgets',
                    'Chart': 'Graphique',
                    'Applications': 'Applications',
                    'Ready to use Apps': `Applications prêtes à l'emploi`
                }
            },
            pt: {
                translations: {
                    'General': 'Geral',
                    'Dashboards,Widgets': 'Painéis, Widgets',
                    'Dashboard': 'painel de controle',
                    'Default': 'Padrão',
                    'Ecommerce': 'Comércio eletrônico',
                    'Widgets': 'Widgets',
                    'Chart': 'Gráfico',
                    'Applications': 'Formulários',
                    'Ready to use Apps': 'Aplicativos prontos para usar',
                    'Sign In': 'Aplicativos prontos para usar',
                    'Enter your email & password to login': 'Aplicativos prontos para usar',
                }
            },
            'pt-BR': {
                translations: {
                    'Home': 'Início',
                    'Yes': 'Sim',
                    'No': 'Não',
                    'Tickets': 'Chamados',
                    'Concern': 'Solicitação',
                    'Pages': 'Páginas',
                    'Hello': 'Olá',
                    'Search': 'Buscar',
                    'Account': 'Conta',
                    'Username': 'Nome de usuário',
                    'Password': 'Senha',
                    'Logout': 'Sair',
                    'Settings': 'Configurações',
                    'how can I help you?': 'Como posso ajudá-lo?',
                    'Welcome to Report Portal': 'Aqui você pode reportar eventos ou enviar solicitações.',
                    'Sign In': 'Entrar',
                    'Enter your email & password to login': 'Insira seu e-mail e senha para entrar',
                    'Welcome to the Report Portal!': 'Bem-vindo ao Portal de Comunicações!',
                    'Vacation': 'Férias',
                    'Support': 'Suporte',
                    'Financial': 'Financeiro',
                    'Please sign in': 'Por favor, faça login',
                    'Form': 'Formulário',
                    'Tasks': 'Tarefas',
                    'No Tasks': 'Sem tarefas',
                    'Comments': 'Comentários',
                    'No Comments': 'Sem comentários',
                    'Type a message here...': 'Digite uma mensagem aqui...',
                    'This field is required': 'Este campo é obrigatório',
                    'Submit': 'Enviar',
                    'Submitting': 'Enviando',
                    'Showing': 'Exibindo',
                    'to': 'até',
                    'of': 'de',
                    'entries': 'registros',
                    'Upload File(s)': 'Carregar arquivo(s)',
                    'Click to upload file': 'Clique para carregar o arquivo',
                    'Upload a file': 'Carregar um arquivo',
                    'Take a picture': 'Tirar uma foto',
                    'Select your country': 'Selecione o país da sua unidade de negócio',
                }
            }
        },
        fallbackLng: 'en',
        debug: false,

        // have a common namespace used around the full app
        ns: ['translations'],
        defaultNS: 'translations',

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
